<template>
  <div class="relative w-full">
    <height ref="height" :show="true" @next="next" @leave="leave" />
  </div>
</template>

<script>
import leave from '@/mixins/leave';
import ScanProcess from '@/modules/scan-process';
import Height from '@/components/MobileScan/Tutorial/Height.vue';

export default {
  name: 'UserHeight',
  mixins: [leave],
  components: {
    Height,
  },
  methods: {
    next() {
      ScanProcess.mobileScanHeight = this.$refs.height.data;
      this.$events.goto('MobileScan/Tutorial');
    },
  },
};
</script>

<style scoped></style>
